import ClassNames from 'classnames'
import React from 'react'
import {
  Grid,
  Section,
  Table
} from './../../../../components'
import {
  WarrantyTermsAndConditionsWrapper
} from './styled'

export class WarrantyBSWMThailandTermsAndConditions extends React.PureComponent {
  render() {
    const {
      registeredTrademarkName,
      prefixRegisteredTrademarkName,
      number,
      spacingBottom,
      intro1,
      intro2,
      intro3,
      intro4,
      intro5,
      intro6,
      intro7,
      intro8,
      heading1,
      heading2,
      heading3,
      type1,
      type2,
      type3,
      type4,
      type5,
      type6,
      type7,
      type8,
      type9,
      type10,
      type11,
      type12,
      type13,
      type14,
      type15,
      type16,
      type17,
      type18,
      type19,
      type20,
      type21,
      type22,
      type23,
      type24,
      table1,
      table2,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'warranty-bswm-terms-and-conditions',
    )

    return (
      <WarrantyTermsAndConditionsWrapper
        className={classes}
      >
        {intro1 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs'>ใบรับประกันนี้เป็นการรับประกันแก่ท่านว่า {prefixRegisteredTrademarkName} <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span> หากได้รับการติดตั้งและบำรุงรักษาอย่างถูกต้องเหมาะสมจะมีระดับความสามารถในการใช้งานที่<br />คาดหมาย อย่างน้อยเท่ากับระยะเวลาที่รับประกัน (เริ่มตั้งแต่วันที่ติดตั้ง)</p></Section>
        }
        {intro2 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs'>อย่างไรก็ตาม ปัญหาและสถานการณ์บางอย่าง (ตามที่ระบุด้านล่าง) ต้องระบุและแก้ไขโดยเร็ว เพื่อให้สามารถใช้งานอย่างเป็นไปได้ดีที่สุด และหากไม่ทำการแก้ไข<br />อาจเป็นผลให้การรับประกันสิ้นผลลง</p></Section>
        }
        {intro3 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs'>ใบรับประกันนี้เป็นการรับประกันต่อการก่อสร้างโดยมีเงื่อนไขว่า อาคารที่พักอาศัยและอาคารพาณิชย์ในประเทศ (“ที่พักอาศัย”) ที่ใช้ส่วนประกอบโครงสร้างเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span>ที่ได้รับการติดตั้ง บำรุงรักษาอย่างเหมาะสม ซึ่งรวมถึงแต่ไม่จำกัดเพียง</p></Section>
        }
        {intro4 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs'>ในบริบทของการรับประกันนี้ “ภายในโครงสร้างเหล็กของอาคาร” ถูกกำหนดเป็นส่วนประกอบโครงสร้างเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span> ทั้งหมด ซึ่งรวมถึง การวางโครงสร้าง<br /> หลังคาไปจนถึงผนังของอาคารที่พักอาศัยและอาคารพาณิชย์ในประเทศ ซึ่งทำให้เกิดช่องว่างหรือช่องเปิดที่ไม่มีการควบคุม ทำให้ส่วนประกอบโครงสร้างติดกับส่วนที่ <br /> ถูกคลุมและปิดทึบทั้งหมดด้วยวัสดุปิดผิวอาคาร เช่น อิฐ อิฐมวลเบา หรือแผ่นไฟเบอร์ซีเมนต์ โครงสร้างชายคา ระเบียง ที่จอดรถข้างอาคาร ทางเชื่อมเข้าอาคาร <br /> และผลิตภัณฑ์หลังคา เช่น เหล็กเคลือบสี COLORBOND® หรือ กระเบื้องคอนกรีต มีการควบคุมความกว้างของช่องว่าง ซึ่งรวมถึงผนังและช่องระบายอากาศ<br /> ที่หน้าจั่วหลังคาที่ติดตั้งตามข้อกำหนดคุณลักษณะเฉพาะของผู้ผลิต โดยรวมถึงตาข่ายกันแมลง หรือตาข่ายที่คล้ายกัน ไปถึงด้านหลังของช่องเปิด ซึ่งป้องกันรอบ<br /> บริเวณช่องระบายอากาศ หรืออุปกรณ์ </p></Section>
        }
        {intro5 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs is-italic'>การบังคับใช้การรับประกันนี้ขึ้นอยู่กับการที่ผู้ผลิตโครงสร้างเหล็กของอาคารจะต้องแจ้งให้บริษัท เอ็นเอส บลูสโคป (ประเทศไทย) จำกัด ทราบ โดยกรอกและนำส่ง<br /> แบบฟอร์มการแจ้งการรับประกันก่อนที่จะจัดส่งโครงสร้างเหล็กของอาคารซึ่งผลิตจากเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-normal is-bold'>{registeredTrademarkName}</span> ไปยังสถานที่ก่อสร้าง<br /> บริษัท เอ็นเอส บลูสโคป (ประเทศไทย) จำกัด สงวนสิทธิในการขอเข้าไปในสถานที่ก่อสร้างเพื่อทำการตรวจสอบโครงสร้างระหว่างการก่อสร้าง</p></Section>
        }
        {intro6 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs'>ภายใต้ข้อกำหนดข้างต้น หากส่วนประกอบโครงสร้างใด ๆ เกิดการผุกร่อนซึ่งนำไปสู่ความเสียหายของโครงสร้างระหว่างระยะเวลารับประกัน บริษัท เอ็นเอส บลูสโคป (ประเทศไทย) จำกัด อาจเลือกที่จะ</p></Section>
        }
        {intro7 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs'>ภายใต้สิทธิใด ๆ ที่กฎหมายที่ใช้บังคับของประเทศไทย หรือรัฐ หรืออาณาเขตใด ๆ ของประเทศไทย ให้แก่บุคคลใด ๆ โดยปริยาย โดยสิทธิดังกล่าวไม่สามารถยกเว้นได้โดยกฎหมาย ความรับผิดของเอ็นเอส บลูสโคป ประเทศไทย จะจำกัดเพียงที่กำหนดไว้ข้างต้นเท่านั้น และจะไม่รวมถึงความเสียหายที่เป็นผลสืบเนื่องใด ๆ โดยไม่จำกัด การรับประกันนี้ไม่นำมาใช้บังคับกับความเสียหายของส่วนประกอบโครงสร้างอื่น นอกจากความเสียหายทางโครงสร้างอันเนื่องมาจากการผุกร่อน</p></Section>
        }
        {intro8 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs'>การรับประกันนี้จัดทำขึ้นทั้งฉบับภาษาอังกฤษและฉบับภาษาไทยหากมีการขัดแย้งกันระหว่างฉบับภาษาอังกฤษและฉบับภาษาไทยให้นำฉบับภาษาอังกฤษมาใช้บังคับ</p></Section>
        }
        {heading1 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs is-bold'>หน้าที่ของเจ้าของอาคาร มีดังนี้</p></Section>
        }
        {heading2 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs is-bold'>การรับประกันนี้ไม่นำมาใช้บังคับกับ</p></Section>
        }
        {heading3 &&
          <Section spacingBottom={spacingBottom}><p className='warranty-bswm-text is-xs is-bold'>การแก้ไขการละเมิดต่อการรับประกัน</p></Section>
        }
        {type1 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>การรับประกันนี้ใช้สำหรับแผ่นหลังคา/ผนังและครอบมุม (flashing) ที่ทำจาก{prefixRegisteredTrademarkName} <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span> คุณภาพสูง แนะนำให้เจ้าของ/ผู้รับเหมาตรวจสอบ<br />ชื่อตราสินค้า <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span> ที่ด้านหลังแผ่นเหล็กก่อนการติดตั้ง โดยการรับประกันนี้ไม่ครอบคลุมถึงรางน้ำ ท่อน้ำ วัสดุยึด ประตู และอุปกรณ์ประกอบอื่นๆ</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type2 &&
          <Section>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>การขนย้ายและติดตั้งแผ่นหลังคา/ผนัง ต้องเป็นไปตามคำแนะนำของทางบริษัทฯ ที่ได้มีการจัดพิมพ์และใช้งานอยู่เป็นฉบับปัจุบัน ณ ช่วงเวลาที่มีการติดตั้ง ทั้งนี้<br />โปรดให้ความระมัดระวังเป็นพิเศษในเรื่องดังต่อไปนี้</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type3 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>วัสดุยึดจะต้องมีคุณสมบัติตาม AS3566 Class 3 หรือ Class 4 และต้องได้รับการรับรองคุณสมบัติดังกล่าวจากผู้จัดหาวัสดุยึด</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type4 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>อุปกรณ์ประกอบ ครอบมุมและชิ้นส่วนประกอบทั้งหมดจะต้องผลิตขึ้นจากโลหะที่มีความเหมาะสมกัน (<span className='warranty-bswm-text is-xs is-bold'>COLORBOND®</span>, <span className='warranty-bswm-text is-xs is-bold'>ZINCALUME®</span> เหล็ก สังกะสี <br />หรืออะลูมิเนียม) หรือได้รับการเคลือบตามคำแนะนำของทางบริษัทฯ ที่ได้มีการจัดพิมพ์และใช้งานอยู่เป็นปัจุบัน เพื่อให้ดูเป็นวัสดุแบบเดียวกัน ครอบมุมควรทำจาก<br />วัสดุเดียวกับแผ่นหลังคา/ผนังด้วย</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type5 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ชั้นเคลือบของแผ่นหลังคา/ผนังที่จัดหาจะต้องไม่มีรอยขีดข่วน ครูด เสียหายหรือเคลือบด้วยสิ่งแปลกปลอม หรือวัสดุที่ไม่เหมาะสมกัน (รวมทั้งสารตกค้างใดๆ <br />จากปล่องระบายอากาศ)</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type6 &&
          <Section>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ความเสียหายของผลิตภัณฑ์ไม่ว่าทั้งหมดหรือบางส่วนเนื่องจากสาเหตุดังต่อไปนี้ ไม่อยู่ภายใต้การรับประกัน</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type7 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ความบกพร่องของผลิตภัณฑ์เนื่องจากการกัดกร่อนหรือหมายถึงกรณีที่มีแผ่นเหล็กผุเป็นรู ในส่วนของสนิมที่พื้นผิวหรือการกัดกร่อนเพียงเล็กน้อยที่รอยโค้งหรือขอบตัด<br />เนื่องจากการใช้งานในสภาพอากาศตามธรรมชาติไม่ถือเป็นความบกพร่องของผลิตภัณฑ์</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type8 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>กรณีพบความเสีบหายหรือชำรุดใด ๆ จะต้องแจ้งให้บริษัท เอ็นเอส บลูสโคป ประเทศไทย ทราบเป็นลายลักษณ์อักษรภายใน 30 วัน นับจากวันที่บริษัท เอ็นเอส บลูสโคป ประเทศไทย เชื่อโดยดุลพินิจแต่เพียงผู้เดียวว่า ความชำรุดบกพร่องดังกล่าวพึงพบได้ตามสมควรในแต่ละสถานการณ์</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type9 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>การรับประกันนี้จัดทำขึ้นทั้งฉบับภาษาอังกฤษและฉบับภาษาไทย หากมีการขัดแย้งกันระหว่างฉบับภาษาอังกฤษและฉบับภาษาไทย ให้นำฉบับภาษาอังกฤษมาใช้บังคับ</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type10 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ความบกพร่องของผลิตภัณฑ์เนื่องจากการซีดจาง, สีหลุดเป็นผงและคราบสกปรกนั้นถูกกำหนดไว้ดังตาราง</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type11 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ส่วนประกอบโครงสร้างที่ติดตั้งตามคำแนะนำที่เผยแพร่ของผู้ผลิต ณ เวลาที่ติดตั้ง และเป็นไปตามกฎหมายอาคารของประเทศไทย</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type12 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ทำการติดตั้งแผ่นกันชื้นระหว่างแผ่นรองฐานกับแผ่นพื้นคอนกรีต</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type13 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ทำการติดตั้งและบำรุงรักษาอย่างต่อเนื่อง (ในช่วงระยะเวลาการรับประกัน) สำหรับแผ่นครอบมุมและการแก้ไขการรั่วซึมอื่นๆ ของรอยรั่วใด ๆ เพื่อขจัดการซึมของน้ำเข้าอาคารอย่างเหมาะสม</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type14 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ที่พักอาศัยที่ตั้งอยู่ห่างจากชายทะเลมากกว่า 300 เมตรหรือห่างจากแหล่งน้ำมากกว่า 100 เมตร</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type15 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ทำการติดตั้งตัวเกี่ยวยึด ต้องเป็นไปตามข้อกำหนด ที่ระบุตามมาตรฐาน AS 3566 และมาตรฐานอื่นๆที่บังคับใช้</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type16 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>สัมผัสกันระหว่าง “วัสดุที่ไม่เข้ากัน” เช่น ท่อทองแดง หรือไม้ที่อาบน้ำยาติดกับส่วนประกอบโครงสร้าง (รายละเอียดวัสดุที่ไม่เข้ากัน สามารถขอรับได้จากบริษัท เอ็นเอส บลูสโคป (ประเทศไทย) จำกัด)</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type17 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>บำรุงรักษาการวางท่อภายในและวัสดุปิดผิวภายนอกทั่วทั้งอาคาร และพื้นที่สาธารณูปโภค</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type18 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ซ่อมแซมท่อที่รั่วซึม หรือการไหลล้น จากวัสดุพีซี</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type19 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ดำเนินการโดยทันทีเพื่อแก้ไขสภาพที่มีสาเหตุจากการสึกหรอ สภาพอากาศ หรือความเสียหายอื่น ๆ กับส่วนประกอบของอาคาร ซึ่งอาจเป็นสาเหตุให้เกิดการเสื่อมสภาพ<br />ของโครงสร้างเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span></p></Grid.Column>
            </Grid>
          </Section>
        }
        {type20 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>จัดทำเอกสารของเหตุการณ์ซึ่งอาจเป็นสาเหตุของการเสื่อมสภาพของโครงสร้างเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span> ซึ่งได้เกิดขึ้น รวมถึงรายละเอียดและระยะเวลาของสภาพนั้นที่ทราบได้</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type21 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ระบบพื้นโครงสร้าง หรือระบบโครงผนังหรือหลังคาคอมโพสิตที่ทำจากเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span> และวัสดุอื่น ๆ เช่น คอนกรีต ไม้ หรือแผ่นไฟเบอร์ซีเมนต์ที่กลบแต่ง<br />หรือพ่นด้วยปูนขาว หรือวัสดุผสมคอนกรีต</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type22 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>กรณีท่อรั่วซึม หรือการไหลล้นจากวัสดุพีซี หรือการบำรุงรักษาการวางท่อภายใน หรือเปลือกอาคาร ที่ไม่เพียงพอ เป็นผลให้เกิด หรือเป็นสาเหตุให้เกิดการเสื่อมสภาพ<br />ของวัสดุโครงสร้างเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span></p></Grid.Column>
            </Grid>
          </Section>
        }
        {type23 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>จัดหาเหล็กเคลือบ clean_colorbond ที่เพียงพอมาเปลี่ยนทดแทนกับส่วนประกอบโครงสร้างที่เสียหาย หรือวัสดุที่เทียบเท่ากันที่มีขนาดที่เหมาะสม และมีความเพียงพอ<br />ด้านโครงสร้างเพื่อเปลี่ยนทดแทนการติดตั้งเดิม หรือ</p></Grid.Column>
            </Grid>
          </Section>
        }
        {type24 &&
          <Section spacingBottom={spacingBottom}>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>{number}.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ชดใช้ค่าใช้จ่ายในการซื้อเหล็กเคลือบ <span className='warranty-bswm-text is-xs is-bold'>{registeredTrademarkName}</span> เพื่อทดแทน</p></Grid.Column>
            </Grid>
          </Section>
        }
        {table1 &&
          <Section spacingBottom={spacingBottom} paddingLeft='17'>
            <Table fluid warranty>
              <Table.Section>
                <Table.Row>
                  <Table.Column className='is-head-column' alignCenter maxWidth='330' minWidth='330' paddingVertical='4' paddingHorizontal='4'>
                    <Section spacingTop='11'><p className='warranty-bswm-text is-xs is-bold'>โทนสี</p></Section>
                  </Table.Column>
                  <Table.Column className='is-head-column' alignCenter maxWidth='230' minWidth='230' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs is-bold'>สีซีดจางสูงสุด <br /> ∆E units Hunterlab <br /> ASTM D-2244 (cleaned)</p>
                  </Table.Column>
                </Table.Row>
              </Table.Section>
              <Table.Section>
                <Table.Row>
                  <Table.Column className='is-body-column' maxWidth='330' minWidth='330' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs'>ทุกสีของสินค้า Bluescope ® Zacs <br /> บริษัทรับประกันสีไม่ซีดจากยาวนาน 5 ปี</p>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='230' minWidth='230' paddingVertical='4' paddingHorizontal='4'>
                    <Section>
                      <Section spacingTop='6'><p className='warranty-bswm-text is-xs is-center'>≤30</p></Section>
                    </Section>
                  </Table.Column>
                </Table.Row>
              </Table.Section>
            </Table>
          </Section>
        }
        {table2 &&
          <Section spacingBottom='5' paddingLeft='17'>
            <Table fluid warranty>
              <Table.Section>
                <Table.Row>
                  <Table.Column className='is-head-column' alignCenter maxWidth='180' minWidth='180' paddingVertical='4' paddingHorizontal='4'>
                    <Section spacingTop='11'><p className='warranty-bswm-text is-xs is-bold'>โทนสี</p></Section>
                  </Table.Column>
                  <Table.Column className='is-head-column' alignCenter maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs is-bold'>สีซีดจางสูงสุด <br /> (∆E units Hunterlab) <br /> ASTM D-2244 (cleaned)</p>
                  </Table.Column>
                  <Table.Column className='is-head-column' alignCenter maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs is-bold'>คราบสกปรกสูงสุด<br /> Dirt Staining (ΔL units CIELAB) <br /> ASTM D-2244 (cleaned)</p>
                  </Table.Column>
                  <Table.Column className='is-head-column' alignCenter maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs is-bold'>อัตราสีหลุดเป็นผงสูงสุด <br /> (Jacobson Test) <br /> AS1580-1991</p>
                  </Table.Column>
                </Table.Row>
              </Table.Section>
              <Table.Section>
                <Table.Row>
                  <Table.Column className='is-body-column' maxWidth='180' minWidth='180' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs'>อ่อน (เช่น Clean Off White)</p>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>6</p></Section>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>≥ -4</p></Section>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>2</p></Section>
                  </Table.Column>
                </Table.Row>
                <Table.Row>
                  <Table.Column className='is-body-column' maxWidth='180' minWidth='180' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs'>ปานกลาง (เช่น Clean Beige)</p>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>9</p></Section>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>≥ -3</p></Section>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>2</p></Section>
                  </Table.Column>
                </Table.Row>
                <Table.Row>
                  <Table.Column className='is-body-column' maxWidth='180' minWidth='180' paddingVertical='4' paddingHorizontal='4'>
                    <p className='warranty-bswm-text is-xs'>เข้ม (เช่น Clean Autumn Red)</p>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>15</p></Section>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>≥ -2</p></Section>
                  </Table.Column>
                  <Table.Column className='is-body-column' maxWidth='170' minWidth='170' paddingVertical='4' paddingHorizontal='4'>
                    <Section><p className='warranty-bswm-text is-xs is-center'>2</p></Section>
                  </Table.Column>
                </Table.Row>
              </Table.Section>
            </Table>
          </Section>
        }
      </WarrantyTermsAndConditionsWrapper>
    )
  }

  static defaultProps = {
    // If you set new default props, you should create propsType for correct styleguide document.
    spacingBottom: '5',
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
